import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { initPushNotifications } from './pushNotifications';
import { initReadingSize } from "./ReadingSize";

// The native (Capacitor) app ships its files inside the app package — a
// service worker adds nothing there, and a stale one intercepting requests
// is the classic Capacitor white-screen-on-launch bug.
const isNativeApp = !!(
  window.Capacitor &&
  window.Capacitor.isNativePlatform &&
  window.Capacitor.isNativePlatform()
);

// Last line of defense: if anything in the app crashes while rendering,
// show a retry screen instead of a blank white page.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#0a0a0f',
            color: '#fff',
            fontFamily: 'Inter, sans-serif',
            padding: '24px',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: '18px', fontWeight: 700, marginBottom: '8px' }}>
            Something went wrong
          </div>
          <div style={{ fontSize: '14px', opacity: 0.7, marginBottom: '20px' }}>
            The app hit an unexpected error.
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#e63946',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 28px',
              fontSize: '15px',
              fontWeight: 600,
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

if (isNativeApp) {
  initPushNotifications();
}


initReadingSize();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);

// Tells the watchdog in index.html that the bundle actually loaded and mounted.
// It used to infer this from "#root is empty", but prerendered pages ship with
// #root already full, so that check silently stopped detecting anything.
window.__BTN_BOOTED = 1;

if ('serviceWorker' in navigator) {
  if (isNativeApp) {
    // Clean up after older app versions that DID register a service worker:
    // unregister it and wipe its caches so a stale worker can never serve
    // (or block) the app shell again.
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
    if (window.caches && caches.keys) {
      caches
        .keys()
        .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
        .catch(() => {});
    }
  } else {
    // Website only: keep the PWA service worker.
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').catch(() => {});
    });
  }
}
